module.exports = require('component-query');


// WEBPACK FOOTER //
// ./~/min-dom/lib/query.js